var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex new-powered-by"},[_c('h5',{staticClass:"powered-by-text"},[_vm._v(_vm._s(_vm.$t("poweredBy")))]),_c('img',{attrs:{"src":_vm.imageUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }